import './Sidebar.css';
import { useLocation, NavLink } from 'react-router-dom';
import { getUserSlice } from '../../context/store/store';

const SidebarLink = ({ to, icon, label, linkProps, currentPath }) => (
  <li className="nav-item">
    <NavLink
      to={to}
      {...linkProps}
      className={`nav-link ${currentPath === to ? 'active' : 'collapsed'}`}
    >
      <i className={`bi ${icon}`}></i>
      <span>{label}</span>
    </NavLink>
  </li>
);

function Sidebar({ open = false, mobile = false, onNavigate = () => {} }) {
  const location = useLocation();
  const { getUserOptions } = getUserSlice();
  const options = getUserOptions();
  const linkProps = { onClick: onNavigate, tabIndex: open ? 0 : -1 };

  return (
    <aside
      id="admin-sidebar"
      className={`sidebar ${open ? 'sidebar-open' : 'sidebar-closed'} ${mobile ? 'sidebar-mobile' : 'sidebar-desktop'}`}
      aria-hidden={!open}
      inert={!open ? '' : undefined}
    >
      <ul className="sidebar-nav" id="sidebar-nav">
        {/* Orden operativo del panel: 1 → 9. */}
        {options.accounts && <SidebarLink to="/accounts" icon="bi-grid" label="Crear cuentas" linkProps={linkProps} currentPath={location.pathname} />}
        {options.movements && <SidebarLink to="/movements" icon="bi-clock-history" label="Movimientos" linkProps={linkProps} currentPath={location.pathname} />}
        {options.brebIngestions === true && <SidebarLink to="/breb-ingestions" icon="bi-inboxes" label="Ingesta Bre-B" linkProps={linkProps} currentPath={location.pathname} />}
        <SidebarLink to="/recharges" icon="bi-grid" label="Recargar saldo" linkProps={linkProps} currentPath={location.pathname} />
        {options.categories && <SidebarLink to="/categories" icon="bi-grid" label={<>Crear categor&iacute;a</>} linkProps={linkProps} currentPath={location.pathname} />}
        {options.services && <SidebarLink to="/services" icon="bi-grid" label="Crear servicio" linkProps={linkProps} currentPath={location.pathname} />}
        {options.combos && <SidebarLink to="/combos" icon="bi-collection" label="Combos" linkProps={linkProps} currentPath={location.pathname} />}
        {options.manageRechargeSettings === true && <SidebarLink to="/recharge-settings" icon="bi-qr-code" label="Configurar recargas" linkProps={linkProps} currentPath={location.pathname} />}
        {options.manageCommercialUsers === true && <SidebarLink to="/commercial-users" icon="bi-people" label="Clientes y distribuidores" linkProps={linkProps} currentPath={location.pathname} />}
        {options.profitability === true && <SidebarLink to="/profitability" icon="bi-bar-chart-line" label="Rentabilidad" linkProps={linkProps} currentPath={location.pathname} />}

        {/* Se conserva la plantilla Gold después del orden solicitado. */}
        {options.manageCredentialTemplate === true && <SidebarLink to="/credential-template" icon="bi-chat-square-text" label="Plantilla Gold" linkProps={linkProps} currentPath={location.pathname} />}
      </ul>
    </aside>
  );
}

export default Sidebar;
